import React from 'react';
import { Toaster } from 'react-hot-toast';

import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import RiEvMedicoCons from './components/rievMedicoCons';

export default function index() {
  return (
    <>
      <MainContent
        titulo='Consulta de evaluaciones médicas y resumen de ingreso'
        component={<RiEvMedicoCons />}
        tableMaxWidth
      />
      
      <Outlet />
    </>
  );
}